import useGenerateSessions from "./useGenerateSession";
import { useContext } from "react";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
import { t } from "i18next";
import { GenerateSessionsActionContext } from "./GenerateSessionsActionContext";
import usePrepareGenerateSessions from "./usePrepareGenerateSessions";

function useGenerateSessionsAction(modelConfig: any, index: any): any {
  const prepareGenerateSessions = usePrepareGenerateSessions();
  const prepareGenerateSessionsFunction = (id: any) => prepareGenerateSessions(id);

  const onSuccessGenerateSessions = () => {
    setShowModal(false);
    index();
  };

  const remove = useGenerateSessions(modelConfig);

  const removeFunction = () => remove(onSuccessGenerateSessions);

  const contextInstance = useContext(GenerateSessionsActionContext);
  const { setShowModal } = contextInstance;

  const modalConfig = {
    contextInstance: contextInstance,
    title: "generate_sessions",
    onSubmit: () => removeFunction(),
  };

  const actionTemplate = (
    <CrudModuleFactoryModal modalConfig={modalConfig}>
      {t(`are_you_sure_you_want_to_generate_the_sessions_of_this_${modelConfig.modelName}?`)}
    </CrudModuleFactoryModal>
  );

  /** END EDIT TABLE ACTION */

  return {
    prepareGenerateSessionsFunction,
    actionTemplate,
  };
}

export default useGenerateSessionsAction;
